/* Footer section 
--------------------------------------*/
class Footer {
    constructor() {
      this.init()
    }
    init = () => {
      this.footerToggle();
      this.footerNewsletter();
    }
    footerToggle = () => {
      const footerLinks = document.querySelectorAll('.footer-toggle .heading-wrapper')
      console.log(footerLinks);
      if (footerLinks) {
        footerLinks.forEach(link => {
          link.addEventListener('click', e => {
            let isEnable = [...document.querySelector('.footer-navigation').classList].join('')
            if (isEnable.includes('footer-toggle')) {
              console.log(link);
              let linksWrapper = link.closest('.link-list-wrapper')
              if (linksWrapper) {
                linksWrapper.classList.toggle('active')
              }
            }
          })
        })
      }
    }
  
    footerNewsletter = () => {
      document.addEventListener("DOMContentLoaded", (event) => {
        var parent = document.querySelector('.newsletter-form-field-wrapper');
        //check already exist or not customer
        if(window.location.href.indexOf("newsletter&form_type=customer") > -1) {
          if(document.querySelector('.newsletter-form-field-wrapper input').value != '') {
            parent?.querySelector('.note--error') && parent?.querySelector('.note--error').classList.remove('hidden');
          }
        }
      });
    };
  
  }
  new Footer